import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getTableLabel } from '../../../../utils/table-utils';
//@ts-expect-error untyped import
import { useTableSource, useProperty } from '../SourceMeta';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpanContainer = styled.div.withConfig({
  displayName: "InvalidStagedPropertyFilterLabel__StyledSpanContainer",
  componentId: "sc-1h56xtt-0"
})(["display:block;font-weight:600;margin-bottom:-4px;"]);
const InvalidStagedPropertyFilterLabel = ({
  propertyFilterRef
}) => {
  const {
    table: tableName,
    property: propertyName
  } = propertyFilterRef;
  const tableSource = useTableSource(tableName);
  const tableLabel = getTableLabel(tableName, tableSource);
  const property = useProperty(tableName, propertyName);
  const errorMessage = I18n.text('reporting-snowflake.filter-editor.relative-time-property');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledSpanContainer, {
      children: /*#__PURE__*/_jsx(Text, {
        children: tableLabel
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: errorMessage,
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-alert-default",
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx("strong", {
            children: (property === null || property === void 0 ? void 0 : property.label) || propertyName
          })
        })
      })
    })]
  });
};
export default InvalidStagedPropertyFilterLabel;